import { Route } from 'src/routes/Route'

export const PurchasePointsRoute = Route({ path: '/purchase-points' })
export type PurchasePointsRoute = Route<typeof PurchasePointsRoute>
